var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotFixed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M27.102 4.005A1 1 0 0 0 27 4h-4a1 1 0 1 0 0 2h1.587l-2.969 2.968a9 9 0 1 0 2.504 10.913A9 9 0 0 0 25 16a8.96 8.96 0 0 0-1.968-5.617L26 7.415V9a1 1 0 1 0 2 0V5a1 1 0 0 0-.898-.995M16.037 23a7 7 0 0 0 .008-14H16a7 7 0 0 0-4.194 1.395A7 7 0 0 0 16 23z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M25 16a8.96 8.96 0 0 1-1.969 5.62A9 9 0 0 1 17 24.944V28h2a1 1 0 1 1 0 2h-2v1a1 1 0 1 1-2 0v-1h-2a1 1 0 1 1 0-2h2v-3.055A9.001 9.001 0 0 1 16 7a9 9 0 0 1 9 9m-8.963 7a7 7 0 0 0 .008-14H16a7 7 0 0 0-4.194 1.395A7 7 0 0 0 16 23z",
  clipRule: "evenodd"
})));
export default SvgNotFixed;